import React from 'react'
import {
  MDBCol,
  MDBRow
} from "mdb-react-ui-kit";
function Certified_comp() {
  const imageUrls = [
    {
      url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Ministry_of_Corporate_Affairs_India.svg/375px-Ministry_of_Corporate_Affairs_India.svg.png',
      alt: 'Ministry of Corporate Affairs India'
    },
    {
      url: 'https://yhills.com/wp-content/uploads/2023/11/YHills-Proudly-Certified-by-MSME-India.webp',
      alt: 'YHills Proudly Certified by MSME India'
    },
    {
      url: 'https://csc.gov.in/assets/images/digital-india.png',
      alt: 'Digital India Logo'
    }
  ]

  return (
    <div className="my-4">

      {/* ------------------------Monile view------------------------ */}
      <div className="pt-3 d-sm-block d-md-none">
        <div className="container">
          <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" className="px-5 text-center pt-2 mobile_collabration_img">
              <h1 className="display-6">We are Proudly Certified by</h1>
              <p className="mt-3">We're thrilled to announce that InternElite has been certified for its outstanding educational offerings, assuring professionals and students of our commitment to excellence.</p>
          </MDBCol>
          </MDBRow>
        </div>
        <div className="container">
            <div className="row d-flex justify-content-center">
              {imageUrls.map((image, index) => (
                <div className={`col-4 text-center ${index === 0 || index === 2 ? 'pt-3' : ''}`} key={index}>
                  <img
                    className='certifide_comp_mobile_icon_image' 
                    src={image.url} alt={image.alt}
                    title={image.title}
                  />
                </div>
              ))}
            </div>
          </div>
      </div>


      {/* ------------------------Dasktop view------------------------ */}
    
      <div className="pt-3 d-md-block d-none">
        <div className="container">
          <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" className="px-5 text-center pt-2 collabration_img">
              <h1 className="display-6">We are Proudly Certified by</h1>
              <p className="mt-3 px-5">We're thrilled to announce that InternElite has been certified for its outstanding educational offerings, assuring professionals and students of our commitment to excellence.</p>
          </MDBCol>
          </MDBRow>
        </div>
        <div className="container mt-2">
            <div className="row d-flex justify-content-center">
              {imageUrls.map((image, index) => (
                <div className={`col-3 text-center ${index === 0 || index === 2 ? 'pt-4' : ''}`} key={index}>
                  <img
                    className='certifide_comp_icon_image' 
                    src={image.url} alt={image.alt}
                    title={image.title}
                  />
                </div>
              ))}
            </div>
          </div>
      </div>
    </div>
  )
}

export default Certified_comp
